module.exports = __webpack_public_path__ + "img/Professional VocabularyQuotient Credential- AI LiteracySpecialist_1120604.6aedcdbe.jpg";